import React from "react";
import CountUp from "react-countup";
import { navigate } from "gatsby"
import LazyLoad from "react-lazyload";
import { Container, Row, Col, Button } from "react-bootstrap";

import imgC from "../../assets/image/l3/jpg/tests.jpg";

const Content = () => {
  return (
    <>
      {/* <!-- Content Area --> */}
      <div className="content-section pt-12 pb-10 bg-default-2 py-xl-25 ">
        <Container>
          <Row className="align-items-center justify-content-md-center">
            <Col lg="4" md="10">
              <div className="content-text text-center text-lg-left mb-9 mb-lg-0 pr-xl-11">
                <h2 className="title gr-text-5 mb-8">
                  Test PCR y antígenos a domicilio
                </h2>
                <p className="gr-text-8 mb-9">
                Hacemos las pruebas de forma discreta y personalizada con o sin certificado (en español o en inglés) y diagnosticamos con nuestro equipo médico.                
                
                </p>
                <Button className="gr-hover-y" onClick={()=>{navigate("#cta-prev")}}>Solicita tests a domicilio</Button>
              </div>
            </Col>
            
            <Col lg="4" md="6">
              <div className="stats-wrapper mt-6 mt-md-0 pl-xl-9">
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <h3 className="title gr-text-5 mb-5">Sanitarios titulados</h3>
                  <p className="gr-text-8 mb-0">
                    Nuestros profesionales sanitarios están altamente cualificados. 
                  </p>
                </div>
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                ><h3 className="title gr-text-5 mb-5">
                <LazyLoad>
                  <span className="counter">
                   Válido para viajar
                    
                  </span>
                </LazyLoad>
              </h3>
              <p className="gr-text-8 mb-0">
                Los certificados emitidos por laboratorios independientes con total fiabilidad. 
              </p>
                  
                </div>
                <div
                  className="single-stat py-6"
                  data-aos="fade-left"
                  data-aos-duration="2000"
                >
                  <h3 className="title gr-text-5 mb-5">
                    <LazyLoad>
                      <span className="counter">
                       Nos desplazamos
                      </span>
                     
                    </LazyLoad>
                  </h3>
                  <p className="gr-text-8 mb-0">
                   Sin colas ni esperas. Efectuamos el servicio personalizado.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="6">
              <div className="content-img rounded-8">
                <img className="w-100 rounded-8" src={imgC} alt="" />
              </div> 
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Content;
